module.exports = __webpack_public_path__ + "img/dish.7e4af4ed.png";